<template>
  <Loader v-if="loading"/>
  <div v-else>
    <h4 class="tab__content__title space__between">{{ $lang.app.PROJECT_USERS }}
      <button v-if="application.actions.some(action => action.constName === 'APPLICATIONS_ADD_EMPLOYMENT_ACTION')"
              class="title__icon" @click="$emitter.emit('openApplicationAddEmploymentModal', application)">
        <svg viewBox="0 0 24 24" width="24" height="24">
          <use xlink:href="@/assets/v2/img/sprite.svg#icon__plus"></use>
        </svg>
      </button>
    </h4>
    <div v-for="(user, index) in users" :key="index" class="resolution__user">
      <div class="resolution__user__left">
        <div class="resolution__user__avatar">
          <img src="@/assets/v2/img/user__avatar.jpg" alt="avatar" class="resolution__user__avatar__img">
        </div>
        <div class="resolution__user__info">
          <div class="resolution__user__name">{{ index + 1 }}. {{ user.employment.fullName }}</div>
<!--          <div class="resolution__user__rule">Куратор</div>-->
        </div>
      </div>
      <div class="resolution__user__right">
        <button v-if="deletable && user.type === applicationEmployeeTypesKeyValue('VIEWER')" @click="removeUser(user)">
          <svg class="icon" viewBox="0 0 24 24" width="24" height="24">
            <use xlink:href="@/assets/v2/img/sprite.svg#icon__remove"></use>
          </svg>
        </button>
      </div>
    </div>

    <AddEmploymentModal/>
  </div>
</template>
<script>
import {getUsers, deleteUser} from "../../../api/employee/application";
import {getValueByKey as applicationEmployeeTypesKeyValue} from "../../../helpers/constants/applicationEmployeeTypes";
import AddEmploymentModal from "./modals/AddEmploymentModal.vue";
export default {
  props: {
    application: Object
  },
  components: {
    AddEmploymentModal
  },
  data() {
    return {
      loading: false,
      users: [],
    }
  },
  mounted() {
    this.fetchUsers()
  },
  beforeMount() {
    this.$emitter.on('refresh-users', (payload) => {
      if(!payload) {
        this.fetchUsers()
      } else {
        this.fetchUsers(payload.reload)
      }
    })
  },
  beforeUnmount() {
    this.$emitter.off('refresh-users')
  },
  computed: {
    deletable() {
      return this.application.actions.some(item => item.constName === 'APPLICATIONS_DELETE_EMPLOYMENT_ACTION')
    }
  },
  methods: {
    applicationEmployeeTypesKeyValue,
    fetchUsers(reload = true) {
      if(reload) {
        this.loading = true
      }
      getUsers(this.application.id).then(res => {
        this.users = res
      }).finally(() => {
        this.loading = false
      })
    },
    removeUser(user) {
      this.$swal.fire({
        icon: 'warning',
        text: this.$lang.app.ARE_YOU_SURE_TO_DELETE,
        showDenyButton: true,
        confirmButtonColor: '#4c9ac7',
        denyButtonColor: '#6e7881',
        confirmButtonText: this.$lang.app.YES,
        denyButtonText: this.$lang.app.NO,
      }).then((result) => {
        if (result.isConfirmed) {
          deleteUser(this.application.id, user.id).then(({data}) => {
            this.$snotify.success(data.message)
            this.fetchUsers(false)
          }).catch(error => {
            this.$snotify.error(error)
          })
        }
      })
    }
  }
}
</script>